
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Radio.html",
      function () {
        return require("private-next-pages/Forms/Radio.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Radio.html"])
      });
    }
  